import {IForm} from '@/components/types'
import dayjs from "dayjs";

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'channelName',
      type: 'select',
      label: '来源',
      clearable: true,
      filterable: true,
      placeholder: '请先选择所属第三方',
      isDisabled: (formData) => !formData.thirdParty,
      options: []
    },
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          const dateString = '2025-04-30 23:59:59';
          const oldDate = new Date(dateString);
          return !dayjs().startOf('day').isAfter(dayjs(date).startOf('day')) || date < oldDate
        }
      }
    }
  ]
}
